import type { AutomationTriggerButton } from "@/schema/automation-trigger-button"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchAutomationTriggerButtons(
  context: ApiContext,
  recordType?: string,
  recordId?: string
): Promise<{ automation_trigger_buttons: AutomationTriggerButton[] }> {
  const searchParams = new URLSearchParams()
  if (recordType) searchParams.set("record_type", recordType)
  if (recordId) searchParams.set("record_id", recordId)
  const qs = searchParams.toString()
  return apiContextFetch<{ automation_trigger_buttons: AutomationTriggerButton[] }>(
    context,
    `automation_trigger_buttons${qs ? `?${qs}` : ""}`
  )
}
